import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    salon_name: "Zen Nails Lounge & Spa",
    book_appointment: "Book Your Appointment",
    a_moment_of_calm: "A moment of calm. By appointment only.",
    individual: "Individual", group: "Group (2-4 people)",
    select_services: "Select Services",
    multi_select_hint: "You may pick more than one",
    next: "Next", back: "Back",
    choose_staff: "Choose Stylist", any_one: "Any Available",
    select_date: "Select Date", select_time: "Select Time",
    your_information: "Your Information",
    full_name: "Full Name", phone_number: "Phone Number",
    notes: "Notes (optional)",
    notes_placeholder: "Any preferences or details we should know",
    confirm_booking: "Confirm Booking",
    booking_confirmed: "Reservation Confirmed",
    booking_confirmed_msg: "We look forward to seeing you.",
    add_to_calendar: "Add to Calendar", new_booking: "New Booking",
    no_slots: "No availability — please pick another date or stylist.",
    welcome_back: "Welcome back",
    customer_login: "Staff & Owner Login", staff_login: "Sign in",
    username: "Username", password: "Password", sign_in: "Sign In",
    duration: "Duration", minutes: "min",
    person: "Person", add_person: "Add another person", remove: "Remove",
    booking_id: "Booking ID", date: "Date", time: "Time",
    stylist: "Stylist", services: "Services",
    invalid_phone: "Please enter a valid phone number",
    name_required: "Please enter your name",
    no_service_selected: "Please choose at least one service",
    booking_failed: "Could not create booking",
    minutes_word: "minutes", today: "Today", tomorrow: "Tomorrow",
    summary: "Summary",
    info_helper: "Enter your phone first — if you've visited us before, we'll find your name automatically.",
    last_time_with_prefix: "Last time you booked",
    with_word: "with",
    book_again_q: "Book again?",
    suggested: "Suggested",
  },
  es: {
    salon_name: "Zen Nails Lounge & Spa",
    book_appointment: "Reserva tu Cita",
    a_moment_of_calm: "Un momento de calma. Solo con cita previa.",
    individual: "Individual", group: "Grupo (2-4 personas)",
    select_services: "Selecciona Servicios",
    multi_select_hint: "Puedes elegir más de uno",
    next: "Siguiente", back: "Atrás",
    choose_staff: "Elige Estilista", any_one: "Cualquiera",
    select_date: "Selecciona Fecha", select_time: "Selecciona Hora",
    your_information: "Tu Información",
    full_name: "Nombre Completo", phone_number: "Teléfono",
    notes: "Notas (opcional)",
    notes_placeholder: "Cualquier preferencia o detalle",
    confirm_booking: "Confirmar Reserva",
    booking_confirmed: "Reserva Confirmada",
    booking_confirmed_msg: "Te esperamos.",
    add_to_calendar: "Añadir al Calendario", new_booking: "Nueva Reserva",
    no_slots: "Sin disponibilidad.",
    welcome_back: "Bienvenido",
    customer_login: "Acceso Personal", staff_login: "Iniciar Sesión",
    username: "Usuario", password: "Contraseña", sign_in: "Entrar",
    duration: "Duración", minutes: "min",
    person: "Persona", add_person: "Añadir otra persona", remove: "Quitar",
    booking_id: "ID de Reserva", date: "Fecha", time: "Hora",
    stylist: "Estilista", services: "Servicios",
    invalid_phone: "Teléfono no válido",
    name_required: "Por favor introduce tu nombre",
    no_service_selected: "Elige al menos un servicio",
    booking_failed: "No se pudo crear la reserva",
    minutes_word: "minutos", today: "Hoy", tomorrow: "Mañana",
    summary: "Resumen",
    info_helper: "Introduce tu teléfono primero — si nos has visitado antes, completaremos tu nombre automáticamente.",
    last_time_with_prefix: "La última vez reservaste",
    with_word: "con",
    book_again_q: "¿Reservar de nuevo?",
    suggested: "Sugerido",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("zen_lang") || "en");
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  const change = (l) => { setLang(l); localStorage.setItem("zen_lang", l); };
  return <I18nContext.Provider value={{ lang, t, setLang: change }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export function formatTime12(hhmm) {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
}

export function formatPhone(s) {
  const d = (s || "").replace(/\D/g, "").slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
